var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contact-us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mock-Ups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback",
    transform: "translate(-137.000000, -979.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(137.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact-us",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5372881,13.2761699 L15.2995291,11.0385082 C14.68258,10.421621 13.678684,10.421621 13.0617701,11.0385082 L12.0446196,12.0556144 C11.5772318,12.5229819 10.8166982,12.5228413 10.3494861,12.0557901 L5.94069757,7.64343149 C5.47221984,7.17497412 5.47214953,6.41675873 5.94069757,5.94823105 C6.10453294,5.78440281 6.57497951,5.31397669 6.95784799,4.93112485 C7.57208998,4.31694472 7.58066848,3.31622134 6.95725031,2.69290058 L4.72008895,0.46286772 C4.10313981,-0.154019443 3.09927905,-0.154019443 2.48398232,0.461250532 C2.02355573,0.917649298 1.87504917,1.06488378 1.66860254,1.26952846 C-0.556183269,3.49418241 -0.556183269,7.11397799 1.66849707,9.33856162 L8.65407138,16.3274885 C10.8840606,18.5574159 14.4933607,18.5575917 16.7235256,16.3274885 L17.5372881,15.5137965 C18.1542373,14.8968742 18.1542373,13.8930923 17.5372881,13.2761699 Z M3.22827303,1.20874326 C3.43391102,1.0031142 3.76847268,1.00307905 3.97477867,1.20930576 L6.21194003,3.43933862 C6.41807023,3.64545986 6.41807023,3.97905776 6.21194003,4.18521416 L5.83895089,4.55815192 L2.85721757,1.57654821 L3.22827303,1.20874326 Z M9.40011998,15.5817185 L2.4145105,8.59272124 C0.693254756,6.87154031 0.598645106,4.16890164 2.12354452,2.33469329 L5.09662903,5.30764856 C4.31542263,6.19319998 4.34797876,7.5426033 5.19461382,8.38920156 L9.60326177,12.8013493 C9.60329692,12.8013844 9.60336724,12.8014547 9.6034024,12.8014899 C10.4491234,13.6472093 11.798515,13.6818733 12.6851948,12.8996462 L15.6583496,15.8726718 C13.8298978,17.3948682 11.1332239,17.3147471 9.40011998,15.5817185 Z M16.7914153,14.767921 L16.4184262,15.1408939 L13.4347592,12.1573215 L13.807678,11.7843837 C14.0133512,11.5787546 14.347948,11.5787195 14.5536211,11.7843837 L16.7913802,14.0220455 C16.9970533,14.2277097 16.9970533,14.5623271 16.7914153,14.767921 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.df193138390d66a95ff6a1e76f54a1b8.svg";
export { ForwardRef as ReactComponent };